import type { FC, ReactNode } from 'react';
import { createPortal } from 'react-dom';
import { QBox } from '../../QLayouts';

const OUTLET_ID = 'q-properties-panel-outlet';

export const QPropertiesPanelOutlet: FC = () => {
  return <QBox id={OUTLET_ID} />;
};

export const QPropertiesPanelPortal: FC<{
  children?: ReactNode;
}> = ({ children }) => {
  const destination = document.getElementById(OUTLET_ID);
  if (!destination) {
    console.error(
      'Cannot render QPropertiesPanel: QPropertiesPanelOutlet was not found!',
    );
    return null;
  }
  return createPortal(children, destination);
};
